import ProgressCard from './ProgressCard';

export default ProgressCard;
